import React, { useEffect, useState } from "react";
import {
  fetchFormData,
  formatDateOnly,
  formatTimeOnly,
} from "../../utils/options";
import Footer from "../shared/Footer";
import { Link } from "react-router-dom";
import Loan_Inquiry2Header from "./Loan_Inquiry2Header";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import { useParams } from "react-router-dom";
import Table from "../shared/table/Table";
import { IBaseUrl } from "../../index";
const Loan_InquiryHistory = () => {
  const { id: inquiryId } = useParams();
  const [loading, setLoading] = useState(false);
  const [inquiryHistory, setInquiryHistory] = useState([]);
  const [inquirytDetails, setInquiryDetails] = useState({});
  const [document, setDocument] = useState([]);

  useEffect(() => {
    if (inquiryId) {
      fetchTaskHistory(inquiryId);
      fetchTaskDetails(inquiryId);
      fetchDocument(inquiryId);
    }
  }, [inquiryId]);

  const fetchTaskDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData(
        "get-lead-inquiry-by-id",
        formData,
        "POST"
      );
      if (result && result.data) {
        setInquiryDetails(result.data);
      } else {
        setInquiryDetails({});
      }
    } catch (error) {
      console.error("Failed to fetch task details:", error);
      setInquiryDetails({});
    }
  };

  const fetchDocument = async (id) => {
    try {
      const formData = new FormData();
      formData.append("inquiry_id", id);

      const response = await fetchFormData("documents/view", formData, "POST");

      console.log("Raw response from API:", response);

      if (response && response.data) {
        const data = Array.isArray(response.data)
          ? response.data
          : [response.data];

        console.log("Formatted document data:", data);

        const formatted = data.map((item) => ({
          id: item.id,
          name: item.document_type || "Unnamed Document",
          url: item.document_url || `${IBaseUrl}/${item.document}`, // fallback if document_url missing
          filePath: item.document,
        }));

        console.log("Final formatted documents:", formatted);

        setDocument(formatted);
      } else {
        console.log("No document data found.");
        setDocument([]);
      }
    } catch (error) {
      console.error("Failed to fetch documents:", error);
      setDocument([]);
    }
  };

  const fetchTaskHistory = async (id) => {
    setLoading(true);
    try {
      const response = await fetchFormData(
        `getLoan-inquiry-history/${id}`,
        {},
        "POST"
      );

      if (response?.data) {
        setInquiryHistory(response.data);
      } else {
        setInquiryHistory([]);
      }
    } catch (error) {
      console.error("Failed to fetch task history:", error);
      setInquiryHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "ActionDetails",
      header: "Action Details",
      cell: ({ row }) => {
        const field = row.original.field || "Unknown Field";
        const changedBy = row.original.changed_by_name || "Unknown User";
        const changedAtRaw = row.original.changed_at;

        const formatDate = (dateString) => {
          if (!dateString) return "-";
          const date = new Date(dateString);
          if (isNaN(date)) return dateString; // Not a valid date
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        };

        const formattedOldValue = formatDate(row.original.old_value);
        const formattedNewValue = formatDate(row.original.new_value);

        const formattedChangedAt = formatDate(changedAtRaw);

        return `${changedBy} changed ${field} from ${formattedOldValue} to ${formattedNewValue}.`;
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Time",
      cell: (info) => formatTimeOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_by_name",
      header: "Action Change By",
      defaultIsVisible: true,
      cell: ({ getValue }) => {
        const name = getValue();
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
      },
    },
  ];

  console.log("Fetched Document Array:", document);

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <Loan_Inquiry2Header />

          <div className="main-content">
            <div className="row">
              <div className="task-details mb-6 lead-form-style">
                <h5 className="section-title">Inquiry Details</h5>
                <form className="details-font">
                  {/* Row 1 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Inquiry Id:</div>
                    <div className="col-2">
                      {inquirytDetails.Inquiries_Id || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Customer Name:</div>
                    <div className="col-2">
                      {inquirytDetails.customer_name || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Phone Number:</div>
                    <div className="col-2">
                      {inquirytDetails.phone_number || "-"}
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Email:</div>
                    <div className="col-2">{inquirytDetails.email}</div>

                    <div className="col-2 fw-semibold">Address:</div>
                    <div className="col-2">
                      {inquirytDetails.address || "-"}
                    </div>

                    <div className="col-2 fw-semibold">State:</div>
                    <div className="col-2">
                      {inquirytDetails.state_name || "-"}
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">District:</div>
                    <div className="col-2">
                      {inquirytDetails.district_name || "-"}
                    </div>

                    <div className="col-2 fw-semibold">City:</div>
                    <div className="col-2">
                      {inquirytDetails.city_name || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Amount:</div>
                    <div className="col-2">
                      {inquirytDetails.loan_amount || "-"}
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Inquiry Source:</div>
                    <div className="col-2">
                      {inquirytDetails.lead_source_name || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Inquiry Type:</div>
                    <div className="col-2">
                      {inquirytDetails.loan_type_name || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Priority:</div>
                    <div className="col-2">
                      {inquirytDetails.lead_priority || "-"}
                    </div>
                  </div>

                  {/* Row 5 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">
                      Inquiry Application Number:
                    </div>
                    <div className="col-2">
                      {inquirytDetails.LoanApplicationNumber || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Transition ID:</div>
                    <div className="col-2">
                      {inquirytDetails.TransitionID || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Status:</div>
                    <div className="col-2">
                      {inquirytDetails.loan_inquiry_status || "-"}
                    </div>
                  </div>

                  {/* row 6 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Prefer Bank:</div>
                    <div className="col-2">
                      {inquirytDetails.preferbankname || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Payouts Type:</div>
                    <div className="col-2">
                      {inquirytDetails.payouts_type || "-"}
                    </div>

                    <div className="col-2 fw-semibold">PayoutDate:</div>
                    <div className="col-2">
                      {inquirytDetails.PayoutDate || "-"}
                    </div>
                  </div>

                  {/* row 7 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Payouts Amount:</div>
                    <div className="col-2">
                      {inquirytDetails.payouts || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Date:</div>
                    <div className="col-2">
                      {inquirytDetails.inquiry_date
                        ? formatDateOnly(inquirytDetails.inquiry_date)
                        : "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Notes:</div>
                    <div className="col-2">
                      {inquirytDetails.inquiry_notes || "-"}
                    </div>
                  </div>

                  {/* row 8 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Assigned User:</div>
                    <div className="col-2">
                      {inquirytDetails.assigned_user || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Created User:</div>
                    <div className="col-2">
                      {inquirytDetails.created_user
                        ? inquirytDetails.created_user.charAt(0).toUpperCase() +
                          inquirytDetails.created_user.slice(1)
                        : "-"}
                    </div>

                    <div className="col-2 fw-semibold">Follow Up Date:</div>
                    <div className="col-2">
                      {inquirytDetails.converted_date
                        ? formatDateOnly(inquirytDetails.follow_up_date)
                        : "-"}
                    </div>
                  </div>
                  <div className="col-12">
                    <h5 className="section-title">Document Image</h5>

                    {Array.isArray(document) && document.length > 0 ? (
                      <div className="row">
                        {document.map((doc, index) => (
                          <div className="col-md-3 col-sm-6 mb-4" key={index}>
                            <div className="card h-100 shadow-sm">
                              <div className="card-body text-center">
                                <h6 className="fw-bold mb-3">{doc.name}</h6>
                                {/\.(jpg|jpeg|png|gif|bmp|webp|png)$/i.test(
                                  doc.url
                                ) ? (
                                  <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={doc.url}
                                      alt={doc.name}
                                      style={{
                                        width: "100%",
                                        height: "140px",
                                        objectFit: "cover",
                                        borderRadius: "4px",
                                        border: "2px solid #ccc",
                                      }}
                                    />
                                  </a>
                                ) : (
                                  <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary"
                                  >
                                    View Document
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No documents found.</p>
                    )}
                  </div>
                </form>
              </div>

              <Table
                data={inquiryHistory}
                columns={columns}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default Loan_InquiryHistory;
